import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import LeadDbService from "../Services/LeadDbService";
import { getIcons } from "../Constant/Constant";
import { interestLevel } from "../../Enum/LeadEnumConstants";

const icons = getIcons();

const statusIcons = Object.freeze({
  Fresh: icons.freshIcon,
  "Registered Client": icons.registeredClient,
  "Follow-up": icons.interestedIcon,
  Dealing: icons.dealingIcon,
  "Deal Lost": icons.dealLostIcon,
  "Not Interested": icons.notInterestedIcon,
  Unanswered: icons.unansweredIcon,
  "Retry Suitable": icons.RetrySuitable,
});

const leadCharacterEmoji = Object.freeze({
  "Not Applicable": icons.NAEmoji,
  None: icons.NAEmoji,
  Excited: icons.excitedEmoji,
  Neutral: icons.neutralEmoji,
  Thinking: icons.ThinkingEmoji,
  Confused: icons.confusedEmoji,
});

const AllLeads = ({ selectedTeam, totalLeadCount }) => {
  const [leads, setLeads] = useState([]);
  const [pages, setPages] = useState([]);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasMoreLeads, setHasMoreLeads] = useState(true);
  const [totalLead, setTotalLead] = useState();

  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const bodTeamId = userData?.teamId?.[0]?.id;

  const fetchLeads = (
    token,
    direction,
    selectedTeamId,
    searchKey,
    pageIndex = currentPage
  ) => {
    setLoading(true);

    LeadDbService.fetchLeads(
      userRole,
      selectedTeamId,
      bodTeamId,
      token,
      direction,
      searchKey
    )
      .then((response) => {
        console.log("API Response:", response.data);
        const responseData = response.data;
        setTotalLead(response.data.maxLeadCount);
        totalLeadCount(response.data.maxLeadCount);
        console.log(totalLead);
        const leadsArray = responseData.leads.map((lead) => {
          return { ...lead, id: lead.leadDocId };
        });

        setLeads(leadsArray);
        setPages([]);
        setNextPageToken(response.data.next);
        setPrevPageToken(response.data.previous);

        // Update the pages state
        const updatedPages = [...pages];
        updatedPages[pageIndex - 1] = leadsArray;
        setPages(updatedPages);

        // Update currentPage
        if (direction === "next") {
          setCurrentPage(currentPage + 1);
        } else if (direction === "previous") {
          setCurrentPage(currentPage - 1);
        }

        // Update hasMoreLeads
        setHasMoreLeads(response.data.next);

        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching leads:", error);
        setLoading(false);
        setHasMoreLeads(false);
      });
  };
  useEffect(() => {
    fetchLeads(null, null, selectedTeam);
  }, [selectedTeam]);

  // useEffect(() => {
  //   if (searchKey) {
  //     setLeads([]);
  //     fetchLeads(null, null, selectedTeam, searchKey);
  //   } else {
  //     fetchLeads(null, null, selectedTeam);
  //   }
  // }, [searchKey, selectedTeam]);

  const handleSearchChange = () => {
    if (searchKey) {
      setLeads([]);
      fetchLeads(null, null, selectedTeam, searchKey);
    } else {
      fetchLeads(null, null, selectedTeam);
    }
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      fetchLeads(null, null, selectedTeam, searchKey);
    }
  };

  const LPAGE = 10;

  const handlePageChange = (token, direction) => {
    const newPage = direction === "next" ? currentPage + 1 : currentPage - 1;

    const totalPages = Math.ceil(totalLead / LPAGE);

    if (pages[newPage - 1]) {
      setLeads(pages[newPage - 1]);
      setCurrentPage(newPage);
      setNextPageToken(newPage < totalPages ? token : null);
      setPrevPageToken(newPage > 1 ? token : null);
      setHasMoreLeads(newPage < totalPages);
    } else {
      fetchLeads(token, direction, selectedTeam, "", newPage);
    }
  };

  const noLeads = leads.length === 0;

  const calculateLastAct = (lastModifiedTime) => {
    const lastModifiedDate = new Date(lastModifiedTime);
    const currentDate = new Date();
    const timeDiff = Math.abs(currentDate - lastModifiedDate);
    const diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) - 1;

    console.log("Last " + lastModifiedDate);
    console.log("Current " + currentDate);

    console.log("Day" + timeDiff);

    return diffDays;
  };

  const getDaysStyle = (days) => {
    if (days < 5) {
      return "text-sky-500";
    } else if (days >= 5 && days <= 10) {
      return "text-yellow-500";
    } else {
      return "text-red-500";
    }
  };

  const formatDaysText = (days) => {
    if (days === 0 || days === 1) {
      days = "Day";
    } else {
      days = "Days";
    }

    return days;
  };
  const navigate = useNavigate();

  const handleLeadInfo = (lead) => {
    console.log("Lead object:", lead);
    console.log("Lead ID:", lead.docId);
    let path = "";
    if (userRole === "Admin") {
      path = `/admin/lead-info/${lead.docId}`;
    } else if (userRole === "CMO") {
      path = `/cmo/lead-info/${lead.docId}`;
    } else if (userRole === "MD") {
      path = `/md/lead-info/${lead.docId}`;
    } else if (userRole === "BOD") {
      path = `/bod/lead-info/${lead.docId}`;
    }
    navigate(path, { state: { lead } });
  };

  useEffect(() => {
    if (searchKey === "") {
      fetchLeads(null, null, selectedTeam);
    }
  }, [searchKey]);

  const getBackgroundClass = (label) => {
    switch (label) {
      case "Gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "Silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "Bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "Diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };
  return (
    <div className="h-[800px] w-full ">
      <div className="flex justify-between flex-col gap-5">
        <div className="flex ">
          <h1 className="text-3xl font-semibold 3xl:text-4xl ml-5">
            All Leads &#40;
            {totalLead !== undefined
              ? totalLead
              : searchKey !== null
              ? leads.length
              : 0}
            &#41;
          </h1>
        </div>
        <div>
          <input
            className="border-customGreen rounded-md border bg-transparent w-[70%] h-10     px-4 mx-5 focus:outline-none"
            placeholder="Search by name or phone number"
            type="search"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value.toLowerCase())}
            onKeyPress={handleSearchKeyPress}
          />
          <button
            className="w-[20%] p-2 text-white h-10  bg-customGreen rounded-md "
            onClick={handleSearchChange}
          >
            {" "}
            Search
          </button>
        </div>
      </div>
      <div className="overflow-y-auto custom-scrollbar  h-3/4 bg-white py-5 px-5">
        {loading ? (
          <div className="flex justify-center items-center h-full">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-customGreen"></div>
          </div>
        ) : noLeads ? (
          <div className="text-center text-gray-500">No leads to show.</div>
        ) : (
          leads.map((lead) => (
            <div
              onClick={() => handleLeadInfo(lead)}
              key={lead.id}
              className="grid grid-cols-2 gap-4 px-10 py-2  xl:px-5 mt-5 rounded-lg shadow-md cursor-pointer"
            >
              <div className=" grid w-4/12 text-ellipsis xl:w-full ">
                <h1
                  title={lead.name}
                  className="text-xl font-bold pt-3 text-ellipsis whitespace-nowrap xl:text-base 4xl:text-2xl truncate "
                >
                  {lead.name.replace(/\b\w/g, (char) => char.toUpperCase())}
                </h1>

                <p className="font-medium  ">
                  Team:{" "}
                  <span className="font-medium 4xl:text-lg whitespace-nowrap truncate">
                    {lead.assignedTeam}
                  </span>
                </p>
                {/* <p className="font-medium  ">
                  Assigned User:{" "}
                  <span className="font-medium 4xl:text-lg whitespace-nowrap truncate">
                    {lead.assignedUser}
                  </span>
                </p> */}
                {/* <p className="font-medium flex items-center space-x-1">
                  <span>Locations:</span>
                  <span title={lead.interestedLocations[0]} className="font-medium 4xl:text-lg w-[120px] truncate overflow-hidden whitespace-nowrap">
                    {lead.interestedLocations[0] || "No Location"}
                  </span>
                  {lead.interestedLocations.length > 1 && (
                    <span className="text-blue-500 font-semibold">
                      +{lead.interestedLocations.length - 1}
                    </span>
                  )}
                </p> */}

                {lead?.leadQuality ? (
                  <div className="flex items-center gap-2 ">
                    <img
                      src={
                        interestLevel.find(
                          (level) => level?.label === lead.leadQuality
                        )?.image
                      }
                      alt={
                        interestLevel.find(
                          (level) => level?.label === lead.leadQuality
                        )?.label
                      }
                    />
                    <div
                      className={`${getBackgroundClass(
                        lead?.leadQuality
                      )} font-semibold`}
                    >
                      {lead?.leadQuality == "None" ? "" : lead.leadQuality}
                    </div>
                  </div>
                ) : (
                  " "
                )}
                {/* <p className="font-medium  ">
                  Created date:{" "}
                  <span className="font-medium 4xl:text-lg whitespace-nowrap truncate">
                    {lead?.createdTime}
                  </span>
                </p> */}
              </div>

              <div className="grid grid-cols-3 gap-14 pt-4 4xl:text-lg xl:text-sm">
                <div className="flex flex-col items-center w-auto pt-2 justify-center ">
                  <img
                    className=" xl:w-12 4xl:w-12"
                    src={statusIcons[lead.status]}
                    alt={lead.status}
                  />
                  <p className="font-medium whitespace-nowrap truncate ">
                    {lead.status}
                  </p>
                </div>

                <div className="flex flex-col items-center w-auto justify-center  ">
                  <div className="">
                    <span
                      className={`text-2xl mr-1 4xl:text-5xl ${getDaysStyle(
                        calculateLastAct(lead.lastModifiedTime)
                      )}`}
                    >
                      {calculateLastAct(lead.lastModifiedTime)}
                      {console.log("Number 2  " + lead.lastModifiedTime)}
                    </span>
                    <span className="text-base text-gray-500 ">
                      {formatDaysText(calculateLastAct(lead.lastModifiedTime))}

                      {console.log("Number 1  " + lead.lastModifiedTime)}
                    </span>
                  </div>
                  <p className="whitespace-nowrap">Last act</p>
                </div>

                <div className="flex flex-col items-center w-auto  pt-2 justify-center ">
                  <img
                    className=" xl:w-8 4xl:w-12"
                    src={leadCharacterEmoji[lead.leadCharacter]}
                    alt={lead.leadCharacter}
                  />
                  <p className="">Type</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      <div className="flex justify-center my-5 gap-10">
        {currentPage > 1 && (
          <button
            onClick={() => handlePageChange(prevPageToken, "previous")}
            className="mx-1 px-3 py-1 border rounded text-blue-500"
          >
            <img
              src={icons.previousPagination}
              className="w-3"
              alt="Previous"
            />
          </button>
        )}
        <span>{currentPage}</span>
        {hasMoreLeads && (
          <button
            onClick={() => handlePageChange(nextPageToken, "next")}
            className="mx-1 px-3 py-1 border rounded text-blue-500"
          >
            <img src={icons.nextPagination} className="w-3" alt="Next" />
          </button>
        )}
        {!hasMoreLeads && !loading && (
          <div className="text-center text-gray-500"></div>
        )}
      </div>
    </div>
  );
};

export default AllLeads;
